import { NgIf, AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from '@angular/material/datepicker';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { BreakpointService, BreakpointServiceInjector } from '@next/core-lib/responsive';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import Utils from 'src/app/shared/utils';

import { DateHelper } from '../../../shared/helpers/dateHelper';
import * as deliveryActions from '../../store/actions/delivery.actions';
import { getDeliveryModuleState } from '../../store/selectors/delivery.selectors';

@Component({
  selector: 'app-delivery-overview-filter',
  templateUrl: 'delivery-overview-filter.component.html',
  styleUrls: ['delivery-overview-filter.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    NgIf,
    MatButton,
    MatIcon,
    MatIconButton,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class DeliveryOverviewFilterComponent implements OnInit {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly breakpoint = inject<BreakpointService>(BreakpointServiceInjector);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  deliveryState$ = this.store.select(getDeliveryModuleState);
  isMobile$ = this.breakpoint.ltLg$;

  formGroup = new FormGroup({
    startDate: new FormControl(null, [Validators.required]),
    endDate: new FormControl(Utils.toUtcDate(new Date()).toString(), [Validators.required]),
  });

  ngOnInit() {
    // Dispatch the filter state starting a year ago today and ending today's date.
    this.store.dispatch(
      deliveryActions.setDeliveriesFilter({
        startDate: DateHelper.addYears(DateHelper.nowUTC(), -1).toISOString(),
        endDate: DateHelper.nowUTC().toISOString(),
      }),
    );
    this.deliveryState$.pipe(take(1)).subscribe((state) => {
      this.formGroup.controls.startDate.setValue(state.startDate);
      this.formGroup.controls.endDate.setValue(state.endDate);
    });
  }

  isValid(): boolean {
    const sDate = Utils.toUtcDate(new Date(this.formGroup.controls.startDate.value)).getTime();
    const eDate = Utils.toUtcDate(new Date(this.formGroup.controls.endDate.value)).getTime();
    return this.formGroup.valid && eDate > sDate;
  }

  applyFilter() {
    // Only execute when form is valid.
    if (this.formGroup.valid) {
      // Get values from the form.
      const sDate = Utils.toUtcDate(
        new Date(this.formGroup.controls.startDate.value),
      ).toISOString();
      const eDate = Utils.toUtcDate(new Date(this.formGroup.controls.endDate.value)).toISOString();

      // Dispatch the state change and get the new data.
      this.store.dispatch(
        deliveryActions.setDeliveriesFilter({
          startDate: sDate,
          endDate: eDate,
        }),
      );
    }
  }
}
